export const sidebarContent = [
  {
    iconName: 'explore',
    text: 'Discover',
    path: '/discover',
  },
  {
    iconName: 'content-type',
    text: 'Content',
    path: '/content',
  },
  {
    iconName: 'jobs',
    text: 'Jobs',
    path: '/jobs',
  },
  {
    iconName: 'company-profile',
    text: 'Profile',
    path: '/company-profile',
  },
  {
    iconName: 'team',
    text: 'Team',
    path: '/team',
  },
  {
    iconName: 'account-settings',
    text: 'Settings',
    path: '/settings',
  },
];

export const adminSidebarContent = [
  {
    hasSeparator: true,
    iconName: 'user-folder',
    text: 'Admin Dash',
    path: '/admin/talent',
  },
  {
    iconName: 'NIL',
    text: 'NIL',
    path: '/nil',
  },
  {
    iconName: 'video-camera-outlined',
    text: 'Originals',
    path: '/originals',
  },
];
